import React, { useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import { phrases, validator } from 'myValidation';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { createFilterOptions } from '@mui/material/useAutocomplete';
import {  withStyles } from '@mui/styles';
import _ from 'lodash';
import { FieldWrapper } from 'components';
import { useStyles } from './style';


const BootstrapInput = withStyles((theme) => ({
  root: {
    '& input': {
      margin: '3px 0',
    },
    'label + &': {
      marginTop: theme.spacing(1.5),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      height: '42.63px',
      boxSizing: 'border-box',
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
      '&:hover': {
        border: 'initial',
      },
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #dfdfdf',
      borderRadius: "8px",
    },
  },
}))(TextField);



const filter = createFilterOptions();

const AutocompleteV = (props) => {
  let {
    name,
    register,
    required,
    errors,
    rules,
    label,
    control,
    list,
    defaultValue = '',
    forceValue,
    onChangeValue,
    asterisk = true,
    preventAddCustomOption = false,
    placeholder = '',
    filterOptions,
    useLocalState = false, // list will be updated async inside and just the value will be passed outside
    getList = () => {},
    ...rest
  } = props;

  const vv = {};
  const classes = useStyles();

  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;
  const [localList, setLocalList] = useState([]);
  const [localSearchText, setLocalSearchText] = useState('');
  const [localListLoading, setLocalListLoading] = useState(false);

  useEffect(() => {
    const getLocalList = async () => {
      if (!getList || !useLocalState) return;
      setLocalListLoading(true);
      const res = await getList(localSearchText);
      setLocalListLoading(false);
      if (!res) return;
      setLocalList(res);
    };

    delayedQuery(localSearchText, getLocalList);
  }, [delayedQuery, getList, localSearchText, useLocalState]);

  if (!label) {
    let nameField = name;

    if (name.includes('[')) {
      nameField = name.split('[')[0];
    }

    if (name.includes('.')) {
      nameField = `${nameField}.${name.split('.').pop()}`;
    }

    label = phrases.attributes[nameField.replace(/\s*\[.*?\]\s*/g, '')];
  }

  if (rules) {
    rules.forEach((item) => {
      if (item.includes('|')) {
        let [funcName, options] = item.split('|');
        const func = validator.validators[funcName];

        if (options.includes('{')) {
          options = JSON.parse(options);
        }

        vv[item] = (value) => {
          if (!func(value, options)) {
            return phrases[funcName].replace(':attribute', label).replace(':param', options);
          }
          return true;
        };
      } else {
        if (item === 'required' && asterisk) {
        }

        const func = validator.validators[item];
        vv[item] = (value) =>
          !func(String(value)) ? phrases[item].replace(':attribute', label) : true;
      }
    });
  }

  const id = `autocompletev-label-${name}`;
  return (
    <FieldWrapper {...props}>
      <Wrapper
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{
          validate: {
            ...vv,
          },
        }}
        render={({ onChange = () => {}, value = null }) => (
          <Autocomplete
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            noOptionsText={
              (list?.length === 0 || localList?.length === 0) &&
              (!localSearchText || localSearchText?.length === 0) &&
              (!rest?.inputValue || rest?.inputValue?.length === 0)
                ? 'جستجو کنید...'
                : 'نتیجه‌ای یافت نشد!'
            }
            {...rest}
            {...(useLocalState
              ? {
                  onInputChange: (e) => {
                    setLocalSearchText(e?.target?.value ?? '');
                  },
                  loading: localListLoading,
                }
              : {})}
            className={classes.root}
            value={forceValue ?? value ?? null}
            onChange={(event, newValue) => {
              if (onChange) {
                if (typeof newValue === 'string') {
                  onChange(newValue);
                } else if (newValue && newValue.inputValue) {
                  onChange(newValue.inputValue);
                } else {
                  onChange(newValue);
                }
              }

              if (onChangeValue) {
                onChangeValue(newValue);
              }
            }}
            filterOptions={
              filterOptions ||
              ((options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (!preventAddCustomOption) {
                  if (params.inputValue !== '') {
                    filtered.push({
                      inputValue: params.inputValue,
                      label: `افزودن "${params.inputValue}"`,
                    });
                  }
                }
                return filtered;
              })
            }
            id={id}
            options={useLocalState ? localList : !list ? [] : !Array.isArray(list) ? [] : list}
            isOptionEqualToValue={(option, value) => {
              return option.value === value.value;
            }}
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return option;
              }
              if (option.inputValue) {
                return option.inputValue;
              }
              return option.label;
            }}
            renderOption={(optionProps, option) => (
              <li {...optionProps}>{option.label ?? option}</li>
            )}
            renderInput={(params) => (
              <>
                <BootstrapInput
                  {...params}
                  placeholder={placeholder}
                  label={null}
                  variant="outlined"
                  autoComplete="off"
                />
              </>
            )}
          />
        )}
      />
    </FieldWrapper>
  );
};

function Wrapper({ control, render = () => {}, ...props }) {
  return control ? (
    <Controller control={control} render={({ field }) => render(field)} {...props} />
  ) : (
    <div>{render({})}</div>
  );
}

export default AutocompleteV;
